const store = {
  state: () => ({
    userinfo: null
  }),
  mutations: {
    setUserinfo(state, data) {
      state.userinfo = data
    }
  },

  getters: {}
}
export default store
